<template>
  <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.625 4.875C0.724456 4.875 0.819839 4.91451 0.890165 4.98484C0.960491 5.05516 1 5.15054 1 5.25V6C1 6.79565 1.31607 7.55871 1.87868 8.12132C2.44129 8.68393 3.20435 9 4 9C4.79565 9 5.55871 8.68393 6.12132 8.12132C6.68393 7.55871 7 6.79565 7 6V5.25C7 5.15054 7.03951 5.05516 7.10983 4.98484C7.18016 4.91451 7.27554 4.875 7.375 4.875C7.47446 4.875 7.56984 4.91451 7.64017 4.98484C7.71049 5.05516 7.75 5.15054 7.75 5.25V6C7.75001 6.92965 7.40471 7.82616 6.78109 8.51561C6.15747 9.20505 5.29999 9.63829 4.375 9.73125V11.25H6.625C6.72446 11.25 6.81984 11.2895 6.89017 11.3598C6.96049 11.4302 7 11.5255 7 11.625C7 11.7245 6.96049 11.8198 6.89017 11.8902C6.81984 11.9605 6.72446 12 6.625 12H1.375C1.27554 12 1.18016 11.9605 1.10984 11.8902C1.03951 11.8198 1 11.7245 1 11.625C1 11.5255 1.03951 11.4302 1.10984 11.3598C1.18016 11.2895 1.27554 11.25 1.375 11.25H3.625V9.73125C2.70001 9.63829 1.84253 9.20505 1.21891 8.51561C0.595288 7.82616 0.249988 6.92965 0.25 6V5.25C0.25 5.15054 0.289509 5.05516 0.359835 4.98484C0.430161 4.91451 0.525544 4.875 0.625 4.875Z"
      :fill="color" />
    <path
      d="M5.5 6C5.5 6.39782 5.34196 6.77936 5.06066 7.06066C4.77936 7.34196 4.39782 7.5 4 7.5C3.60218 7.5 3.22064 7.34196 2.93934 7.06066C2.65804 6.77936 2.5 6.39782 2.5 6V2.25C2.5 1.85218 2.65804 1.47064 2.93934 1.18934C3.22064 0.908035 3.60218 0.75 4 0.75C4.39782 0.75 4.77936 0.908035 5.06066 1.18934C5.34196 1.47064 5.5 1.85218 5.5 2.25V6ZM4 0C3.40326 0 2.83097 0.237053 2.40901 0.65901C1.98705 1.08097 1.75 1.65326 1.75 2.25V6C1.75 6.59674 1.98705 7.16903 2.40901 7.59099C2.83097 8.01295 3.40326 8.25 4 8.25C4.59674 8.25 5.16903 8.01295 5.59099 7.59099C6.01295 7.16903 6.25 6.59674 6.25 6V2.25C6.25 1.65326 6.01295 1.08097 5.59099 0.65901C5.16903 0.237053 4.59674 0 4 0Z"
      :fill="color" />
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#242424',
    },
    size: {
      type: Number,
      default: 12,
    },
  },
};
</script>

